import _ from 'lodash'
import { call, select, put } from 'redux-saga/effects'

import actions from 'actions'
import api from 'services'
import { fetchEntity } from 'utils/sagas'
import { getChangedDraftEventGroup } from 'selectors/event-group'

const { eventGroup, draftEventGroupCancel, resetErrorMessage } = actions

const fetchEventGroupUpdate = fetchEntity.bind(
  null,
  eventGroup,
  api.updateEventGroup
)

export function* eventGroupUpdateSaga() {
  const changeEventGroup = yield select(getChangedDraftEventGroup)
  if (_.has(changeEventGroup, 'id')) {
    yield call(fetchEventGroupUpdate, changeEventGroup.id, changeEventGroup)
  } else {
    yield put(draftEventGroupCancel())
  }
}

export function* draftEventGroupSuccessSaga() {
  yield put(resetErrorMessage())
  yield put(draftEventGroupCancel())
}

export function* draftEventGroupCancelSaga() {
  yield put(resetErrorMessage())
}




/** WEBPACK FOOTER **
 ** ./src/sagas/event-group-details/event-group-details-sagas.js
 **/